/** Keep in sync with /src/benchling/config_migration/importer/primitives/action.py */
export enum ObjectActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  IGNORE = 'IGNORE',
  KEEP = 'KEEP',
}
